// 速率显示的共用口径(前端)
// ============================================================
// 「网关总览 → 在飞请求」表和「令牌管理 → 速度」列显示的是同一个量:
//   tps = 客户端实际收到的输出速度(token/s),已含降速效果。
// 两个页面必须用同一套取值/格式化规则,否则用户拿两边互相对照会以为
// 「令牌页 80 t/s、总览 120 t/s」是网关出问题,其实只是两边口径不同。
//
// ⚠️ tps 是**字符推算**的 token 数 ÷ 时间,不是上游给的真实 token 数,
//   误差约 ±20%。两个面板用的是同一个估算器 → 误差方向一致,仍然可比。

// 统一格式化:两边必须一模一样(1 位小数 + 空格 + t/s)
export function fmtTps(tps) {
  if (tps == null || !(tps > 0)) return null;
  return tps.toFixed(1) + ' t/s';
}

// 把一张卡的「在飞请求」拆开成面板要用的几类
//
//   running  已经在打上游的
//   queued   还在等并发槽的(还没打到上游,谈不上速度)
//   withTps  已经出字、能算出速率的
//   pending  在跑但还没出第一个字(等上游预填充 / 深度思考)
//   best     withTps 里最快的那个(代表这张卡此刻的能力上限)
//   others   withTps 里其余的(令牌页要一并列出来,才能和总览逐条对上)
//   thinking 正在深度思考的
export function summarizeLive(live) {
  // 容错:接口偶尔给出 null 项也不该把整个表格渲染炸掉
  const list = (Array.isArray(live) ? live : []).filter((x) => x && typeof x === 'object');
  const queued = list.filter((x) => x.phase === 'queued');
  const running = list.filter((x) => x.phase !== 'queued');
  const withTps = running.filter((x) => x.tps != null && x.tps > 0);
  const pending = running.filter((x) => !(x.tps != null && x.tps > 0));
  const best = withTps.length
    ? withTps.reduce((a, b) => (b.tps > a.tps ? b : a))
    : null;
  const others = withTps
    .filter((x) => x !== best)
    .sort((a, b) => b.tps - a.tps);
  const thinking = running.filter((x) => (x.reasoning_tokens || 0) > 0);
  return { list, queued, running, withTps, pending, best, others, thinking };
}

// 「在飞」请求的状态文案(与网关总览的「状态」列一致)
export function liveStatusText(x) {
  if (x.phase === 'queued') return '排队中';
  return x.stream ? '流式' : '非流式';
}

// 已用时格式化(与网关总览的「已用时」列一致)
export function fmtElapsed(ms) {
  if (ms == null) return '—';
  return ms >= 1000 ? (ms / 1000).toFixed(1) + 's' : ms + 'ms';
}
